<template>
  <div class="content-body">
    <div class="top">消息中心</div>
    <div class="body">
      <div class="condition">
        <div class="table">
          <el-radio-group v-model="activeName" style="margin-bottom: 30px;">
            <el-radio-button label="first">全部消息</el-radio-button>
            <el-radio-button label="second">系统消息</el-radio-button>
            <el-radio-button label="third">新功能上线</el-radio-button>
            <el-radio-button label="fourth">审核消息</el-radio-button>
            <el-radio-button label="five">包断通知</el-radio-button>
          </el-radio-group>

          <el-collapse accordion v-show="activeName === 'first' || activeName === 'fourth'">
            <el-collapse-item>
              <template slot="title">
                <i class="fa fa-envelope-o" aria-hidden="true"></i><span style="margin:0 30px 0 10px;">审核消息</span>账号审核成功通知
              </template>
              <div style="margin-top: 15px;">账号审核成功通知</div>
              <div style="margin-top: 5px;">您的账号审核成功！</div>
            </el-collapse-item>
          </el-collapse>
          <div v-show="activeName !== 'first' && activeName !== 'fourth'" style="text-align: center; font-size: 14px; color: #333; height: 47px; line-height: 47px;">暂无数据</div>

          <!-- <el-tabs v-model="activeName" type="card" size="small">
              <el-tab-pane label="全部消息" name="first">

              </el-tab-pane>
              <el-tab-pane label="系统消息" name="second">
                <div style="text-align: center; font-size: 14px; color: #333; height: 47px; line-height: 47px;">暂无数据</div>
              </el-tab-pane>
              <el-tab-pane label="新功能上线" name="third">
                <div style="text-align: center; font-size: 14px; color: #333; height: 47px; line-height: 47px;">暂无数据</div>
              </el-tab-pane>
              <el-tab-pane label="审核消息" name="fourth">
                <el-collapse accordion>
                  <el-collapse-item>
                    <template slot="title">
                      <i class="fa fa-envelope-o" aria-hidden="true"></i><span style="margin:0 30px 0 10px;">审核消息</span>账号审核成功通知
                    </template>
                    <div>账号审核成功通知</div>
                    <div>您的账号审核成功！</div>
                  </el-collapse-item>
                </el-collapse>
              </el-tab-pane>
              <el-tab-pane label="包断通知" name="five">
                <div style="text-align: center; font-size: 14px; color: #333; height: 47px; line-height: 47px;">暂无数据</div>
              </el-tab-pane>
            </el-tabs> -->
          <div class="page-c">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page"
              :page-sizes="[10, 20, 30, 40, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pageTotal"
              v-show="activeName === 'first' || activeName === 'fourth'"
              >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'bill',
  data() {
    return {
      page: 1,
      pageSize: 10,
      pageTotal: 1,
      activeName: 'first'
    };
  },
  mounted() {
    this.$function.hiddenLoading();
  },
  methods: {
    handleSizeChange(value) {
      this.page = 1;
      this.pageSize = value;
    },
    handleCurrentChange(page) {
      this.page = page;
    }
  },
  watch: {

  }
};
</script>

<style lang="less">
  .el-radio-button__inner {
    border: 1px solid #0D98E2 !important;
    border-left: 0 !important;
    color: #0D98E2 !important;
  }
  .el-radio-button:first-child .el-radio-button__inner {
    border-left: 1px solid #0D98E2 !important;
  }
  .is-active .el-radio-button__inner {
    color: #FFF !important;
  }
  .top {
    height: 54px;
    background-color: #f9f9f9;
    margin-bottom: 31px;
    font-size: 16px;
    font-weight: 700;
    color: #333;
    padding-left: 22px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left-z {
      display: flex;
    }
    .status {
      font-size: 14px;
      color: #999;
      font-weight: 400;
      margin-left: 30px;
      span {
        color: #0782c3;
      }
    }
    .btn {
      float: right;
      margin-right: 40px;
    }
  }

  .body {
    padding: 0px 44px;
  }

  .condition {
    margin-top: 20px;
    width: 1350px;
    height: 55px;
    .page-c {
      margin-top: 20px;
      text-align: right;
    }
  }

</style>
